import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _JSXStyle from "styled-jsx/style";
import React from 'react';
import withDefaults from '../utils/with-defaults';
var defaultProps = {
  className: ''
};

var FieldsetFooterStatus = function FieldsetFooterStatus(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "children"]);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: "jsx-478630753" + " " + (props && props.className != null && props.className || className || "")
  }), children), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "478630753"
  }, "div.jsx-478630753{font-size:0.875rem;line-height:1.2;margin:0;display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;word-break:break-word;}div.jsx-478630753>p{margin:0;}"));
};

var MemoFieldsetFooterStatus = React.memo(FieldsetFooterStatus);
export default withDefaults(MemoFieldsetFooterStatus, defaultProps);